import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AlipaySquareFilledSvg from "@ant-design/icons-svg/es/asn/AlipaySquareFilled";
import AntdIcon from "../components/AntdIcon";
var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlipaySquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AlipaySquareFilled.displayName = 'AlipaySquareFilled';
}
export default /*#__PURE__*/React.forwardRef(AlipaySquareFilled);